//トップページ　キービジュアルスライダー
export function idxFunc() {
  let jsBtn;
  jsBtn = $('#jsBtn');
  jsBtn.on('click', function () {
    alert('wrs');
  });
}